/** The `positionListID` meaning "wherever the arm already is". */
export const CURRENT_POSITION_ID = 'current-position';

/**
 * Whether a target moves relative to wherever the arm already is, rather than
 * to a saved pose.
 *
 * The id alone decides it. The editor emits `positionListID` for both the
 * `'positionList'` and `'relative'` target kinds, so `targetKind` never
 * reaches the runner and an editor-side rule that also tested it would
 * disagree with the runner on data the runner treats as relative-to-current.
 */
// `object &` is what lets a caller pass a target shape that carries a pose
// instead of an id: a type whose every property is optional otherwise rejects
// any argument with no property in common with it.
export function isCurrentPositionTarget(
  target: object & { positionListID?: string | null },
): boolean {
  return target.positionListID === CURRENT_POSITION_ID;
}
